import React from "react";

const MyAccount = () => {
    return (
        <div className="container-fluid">
            <h1 className="display-4 text-center fw-semibold">
                My Account Page!
            </h1>
        </div>
    );
};

export default MyAccount;
